//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { LocalizationInfo } from './LocalizationInfo';
import { PaymentProcessorDisplayItem } from './PaymentProcessorDisplayItem';
import { PaymentSurchargeDisplayItem } from './PaymentSurchargeDisplayItem';

export class PortalSettingsDisplayItem extends ItemBase {
    LocalizationInfo: LocalizationInfo | null = null;
    MaximumProfileImageSizeInBytes: number = 0;
    MinimumPasswordLength: number = 0;
    PaymentProcessor: PaymentProcessorDisplayItem | null = null;
    PaymentSurchargeACH: PaymentSurchargeDisplayItem | null = null;
    PaymentSurchargeCreditCard: PaymentSurchargeDisplayItem | null = null;
    SchoolName: string | null = null;
    SchoolID: string | null = null;
    IsMultiTeacher: boolean = false;

    constructor(initializer?: Partial<PortalSettingsDisplayItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "PortalSettingsDisplayItem";
}
